// @flow
import ExtendableError from 'es6-error';

export class HttpError extends ExtendableError {
  status: ?number;
  message: string;

  constructor(message: string, status: ?number) {
    super(message);
    this.status = status;
  }
}

export class ClientError extends HttpError {}

export class ServerError extends HttpError {}

export class NetworkingError extends ExtendableError {
  constructor(message: string = 'Connection Error') {
    super(message);
  }
}

export default {
  isHttpError(err: any) {
    return err instanceof HttpError;
  },
  isClientError(err: mixed) {
    return err instanceof ClientError;
  },
  isServerError(err: mixed) {
    return err instanceof ServerError;
  },
  isNetworkingError(err: mixed) {
    return err instanceof NetworkingError;
  },
};



// WEBPACK FOOTER //
// ./src/lib/errors/Errors.js